import { useAllowedHeaders } from './hooks/useCustomDataSources';

export default function HeadersToolTipInfo() {
  const { data: allowedHeaders = [] }: { data: string[] } = useAllowedHeaders();
  return (
    <>
      <h5 className="mb-2">Allowed headers</h5>
      <ul className="list-unstyled ps-0">
        {allowedHeaders?.sort().map((header) => (
          <li key={header} style={{ fontFamily: 'monospace' }}>
            {header}
          </li>
        ))}
      </ul>
      <p className="mt-2 text-muted">
        If there is a header you need that is not listed, please{' '}
        <a
          href="https://pratus.disastertech.com/knowledge/kb-tickets/new"
          target="_blank"
          rel="noopener noreferrer"
        >
          contact us
        </a>
      </p>
    </>
  );
}
